import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { pricePlanCalc } from "../../../../services/utils";
import "./PlanCard.css";
import SelectUser from "../SelectUser/SelectUser";
import useSelectUser from "../SelectUser/SelectUser.hooks";
import usePlans from "../../Plans/plans.hooks";
import CustomToolTip from "../../../../components/CustomToolTip/CustomToolTip";
import { InfoToolTip } from "../../../../components";
import { BASE_URL, DASHBOARD_URL } from "../../../../constants";
export default function PlanCard({
  plan,
  selectPlan,
  subscriptionType,
  organizationCredits,
  seats,
  onCompareToggle,
  setAddCredits,
  selectedPlan,
  isCurrentSelected,
  plans,
  handleSeats,
  minSeats,
  isCustom,
  deactivatePlan,
  isVersion2,
}) {
  const [currentPlan, setCurrentPlan] = useState(plan);
  const [current, setCurrent] = useState(null);
  const { usersAndCredits, defaultUsersAndCredits } = useSelectUser({
    planId: plan.planId,
    minSeats,
  });
  const [selectedUser, setSelectedUser] = useState(defaultUsersAndCredits);
  const staticPlan = usePlans(plan, isCustom);
  useEffect(() => {
    let thisPlan = { ...plan };
    if (
      organizationCredits &&
      organizationCredits.plan &&
      organizationCredits.plan.version == 1 &&
      organizationCredits.plan.planId === thisPlan.planId
    ) {
      thisPlan.yearly = organizationCredits.plan.numberOfMonths === 12;
    } else {
      if (isCustom) return;
      if (subscriptionType === "yearly") {
        thisPlan.yearly = true;
      } else {
        thisPlan.yearly = false;
      }
    }
    setCurrentPlan(thisPlan);
    if (organizationCredits && organizationCredits.plan) {
      setCurrent(
        (organizationCredits.plan.planId == thisPlan.planId &&
          thisPlan.planId == "0") ||
          (organizationCredits.plan.numberOfMonths == 12 &&
            organizationCredits.plan.planId == thisPlan.planId &&
            thisPlan.yearly) ||
          (organizationCredits.plan.numberOfMonths !== 12 &&
            organizationCredits.plan.planId == thisPlan.planId &&
            !thisPlan.yearly)
      );

      /*     setCurrent(
        organizationCredits.plan.numberOfMonths == 12 &&
          organizationCredits.plan.planId == thisPlan.planId &&
          thisPlan.yearly == true
          ? true
          : organizationCredits.plan.numberOfMonths !== 12 &&
            organizationCredits.plan.planId == thisPlan.planId &&
            thisPlan.yearly == false
          ? true
          : false
      );*/
    } else {
      setCurrent(thisPlan.planId == "0");
    }

    if (
      organizationCredits &&
      organizationCredits.plan.version == 1 &&
      thisPlan.planId == "plan_12"
    ) {
      setCurrent(true);
    }
    if (subscriptionType == "monthly" && plan.planId == "plan_3") {
      setCurrentPlan({ ...currentPlan, yearly: true });
    }
  }, [subscriptionType, plans]);

  const handleSelectPlan = (plan, type) => {
    if (type) {
      setAddCredits({ type, active: true });
    }
    selectPlan({
      ...plan,
      addCreditsToggle: type ? { type, active: true } : undefined,
    });
  };
  const handleSelectSeats = (users) => {
    setCurrentPlan({ ...currentPlan, numberOfSeats: users });
    handleSeats(users, plan.planId);
  };
  if (!currentPlan) return <div />;
  return (
    <div id={"plan-card"}>
      <div
        className={
          !isCurrentSelected || deactivatePlan
            ? "deactivate-plan"
            : "activate-plan"
        }
      >
        <div className={"plan-card-header"}>
          <h4 className={"title "}>{currentPlan.name}</h4>
          <p className="text-price">
            <span className={"price"}>
              {pricePlanCalc({
                price: currentPlan.pricePerSeat,
                yearly: currentPlan.yearly,
                planId: currentPlan.planId,
              })}
              €
            </span>
            {/* <FormattedMessage id={"billing.excludingTax"} />*/}
            <span className={"mo_user"}>
              <FormattedMessage id={"billing.moUser"} />
            </span>
            {currentPlan.onlyAnnual && (
              <span
                className={"billed_annually_org"}
                style={subscriptionType == "yearly" ? { color: "#888" } : {}}
              >
                <FormattedMessage
                  id={"billing.billedAnnually5UsersMin"}
                  values={{
                    span: (chunk) => <span>{chunk} </span>,
                  }}
                />
              </span>
            )}
          </p>
          <span style={isCustom ? { pointerEvents: "none" } : {}}>
            <SelectUser
              selectSeats={handleSelectSeats}
              plan={currentPlan}
              seats={seats}
              usersAndCredits={usersAndCredits}
              setSelectedUser={setSelectedUser}
              selectedUser={selectedUser}
            />
          </span>

          {plan.planId == "0" ? (
            <CustomToolTip
              element={
                <FormattedMessage
                  id={"home.onboarding.goldInvitesDesc"}
                  values={{ strong: (chunk) => <strong> {chunk}</strong> }}
                />
              }
              style={{ width: 200, top: 20 }}
            >
              <div className={"unlimited-b2b"}>
                <img src="/assets/images/star-vector.svg" alt="" />{" "}
                <FormattedMessage id={"billing.unlimitedB2bCredits"} />
                <img
                  style={{ width: 14, marginLeft: 5 }}
                  src="/assets/images/icon-info.svg"
                  alt=""
                />
              </div>
            </CustomToolTip>
          ) : (
            <div className={"unlimited-b2b"}>
              <img src="/assets/images/star-vector.svg" alt="" />{" "}
              <FormattedMessage id={"billing.unlimitedB2bCredits"} />
            </div>
          )}
          <div className={"select-credits-container"}>
            <div
              className={"select-credits"}
              style={currentPlan.version == 1 ? { opacity: 0 } : {}}
            >
              <p>
                <FormattedMessage
                  id={"phoneCredits"}
                  values={{
                    value:
                      plan.phoneCredits *
                      (subscriptionType == "yearly" ? 12 : 1),
                  }}
                />
                {currentPlan.planId !== "0" && isVersion2 && (
                  <span
                    onClick={() =>
                      handleSelectPlan(currentPlan, "phoneCredits")
                    }
                  >
                    +
                  </span>
                )}
              </p>
              <p>
                <FormattedMessage
                  id={"personalEmailCredits"}
                  values={{
                    value:
                      plan.personalEmailCredits *
                      (subscriptionType == "yearly" ? 12 : 1),
                  }}
                />
                {currentPlan.planId !== "0" && isVersion2 && (
                  <span
                    onClick={() =>
                      handleSelectPlan(currentPlan, "personalEmailCredits")
                    }
                  >
                    +
                  </span>
                )}
              </p>
              <p>
                <FormattedMessage
                  id={"exportCredits"}
                  values={{
                    value:
                      plan.exportCredits *
                      (subscriptionType == "yearly" ? 12 : 1),
                  }}
                />
                {currentPlan.planId !== "0" && isVersion2 && (
                  <span
                    onClick={() =>
                      handleSelectPlan(currentPlan, "exportCredits")
                    }
                  >
                    +
                  </span>
                )}
              </p>
            </div>
            {currentPlan.version == 1 && (
              <div className={"select-credits legacy-cd"}>
                {currentPlan.legacyCreditsPerSeat}{" "}
                <FormattedMessage id={"credits"} />
              </div>
            )}
          </div>
        </div>
        <div className={"plan-card-content"}>
          {/*   {current ? (
            organizationCredits.subscription ? (
              <a className="plan-btn current" href={DASHBOARD_URL + "/billing/info?addLicense=true"}>
                Upgrade{" "}
                {defaultUsersAndCredits.users === selectedUser.users
                  ? selectedUser.users + 1
                  : selectedUser.users}{" "}
                users
              </a>
            ) : (
              <a className="plan-btn current">
                <FormattedMessage id={"billing.currentPlan"} />
              </a>
            )
          ) : (
            <a
              className="plan-btn"
              onClick={() => handleSelectPlan(currentPlan)}
            >
              <FormattedMessage id={"billing.choosePlan"} />
            </a>
          )}*/}
          {current ? (
            <a className="plan-btn current">
              <FormattedMessage id={"billing.currentPlan"} />
            </a>
          ) : (
            <a
              className="plan-btn"
              onClick={() => handleSelectPlan(currentPlan)}
            >
              <FormattedMessage id={"billing.choosePlan"} />
            </a>
          )}
          <PlanPermissions staticPlan={staticPlan} />
        </div>
        {onCompareToggle && (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <a
              className={"view-more-details"}
              onClick={() => onCompareToggle(true)}
              href={"#compare-plans-scroll"}
            >
              <FormattedMessage id={"billing.viewMoreDetails"} />
              {/*   <img src="/assets/images/ic-arrow-right.svg" alt="" />*/}
            </a>
          </div>
        )}
      </div>
      <div id={"compare-plans-scroll"}></div>
    </div>
  );
}

function PlanPermissions({ staticPlan }) {
  return (
    <ul className="permissions">
      {staticPlan &&
        staticPlan.permissions.map((permission, i) => (
          <li key={i}>
            <span className={"permission-line"}>
              <img src="/assets/images/round-check.png" alt="" />{" "}
              <span className={"permission-name"}>
                {/*  <FormattedMessage
                      id={"billing.permissions." + permission.name}
                    />*/}
                {permission.name}
                {permission.toolTip && (
                  <CustomToolTip
                    element={
                      <div style={{ width: 250 }}>{permission.toolTip}</div>
                    }
                    style={{ left: 15 }}
                  >
                    <img src="/assets/images/icon-info.svg" alt="" />{" "}
                  </CustomToolTip>
                )}
              </span>
            </span>
          </li>
        ))}
    </ul>
  );
}
